// extracted by mini-css-extract-plugin
export default {"home__form":"About_home__form__SqO7f","home__header":"About_home__header__RNa8o","home__button":"About_home__button__WCrno"};